// Bulk-load comprehension-check questions from an .html file — the SAME format as
// the KMS Reading Quiz editor (backend/kms/templates/admin/quiz_form.html), so one
// file works in both: one `.quiz-question` block per question, a `.q` prompt,
// `<li>` options (the right one with class="correct" or a data-correct attribute)
// and an optional `.explanation`. Parsed in the browser with DOMParser (inert —
// nothing in the file runs); the author reviews the cards and saves as usual.
export const QUIZ_HTML_EXAMPLE = `<div class="quiz-question">
  <p class="q">What is the main purpose of the dashboard?</p>
  <ol class="options">
    <li>Track daily expenses</li>
    <li class="correct">See your whole financial life on one page</li>
    <li>Pick stocks</li>
  </ol>
  <p class="explanation">One page shows net worth, cash flow and goal dates.</p>
</div>`;

export function parseQuizHtml(htmlText) {
  const doc = new DOMParser().parseFromString(htmlText || '', 'text/html');
  const out = [];
  doc.querySelectorAll('.quiz-question').forEach((b) => {
    const qEl = b.querySelector('.q') || b.querySelector('p, h1, h2, h3, h4');
    const q = qEl ? (qEl.textContent || '').trim() : '';
    const options = [];
    let correct = 0;
    b.querySelectorAll('li').forEach((li) => {
      const text = (li.textContent || '').trim();
      if (!text) return;
      if (li.classList.contains('correct') || li.hasAttribute('data-correct')) correct = options.length;
      options.push(text);
    });
    const expEl = b.querySelector('.explanation');
    const explanation = expEl ? (expEl.textContent || '').trim() : '';
    if (q && options.length >= 2) {
      const opts = options.slice(0, 6);
      out.push({ q, options: opts, correct: correct < opts.length ? correct : 0, explanation });
    }
  });
  return out;
}
